exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SoundBar-module__wrapper___3LLT-{display:grid;gap:1em;grid-auto-flow:column;z-index:1;background-color:#181818;padding:1em;border-radius:15px;justify-content:center}.SoundBar-module__wrapper___3LLT- .SoundBar-module__relative___10myr{position:relative}.SoundBar-module__wrapper___3LLT- .SoundBar-module__overlay___W5fTP{display:flex;justify-content:center;align-items:center;position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer!important}.SoundBar-module__wrapper___3LLT- .SoundBar-module__overlay___W5fTP svg{font-size:18px}.SoundBar-module__wrapper___3LLT- .SoundBar-module__placeholder___2vSOs{width:40px;height:40px}", ""]);

// exports
exports.locals = {
	"wrapper": "SoundBar-module__wrapper___3LLT-",
	"relative": "SoundBar-module__relative___10myr",
	"overlay": "SoundBar-module__overlay___W5fTP",
	"placeholder": "SoundBar-module__placeholder___2vSOs"
};